import React, { useContext } from 'react';

import { RicosViewerContext } from './../../ricos-context';
import type { ComponentData, NodeViewRendererProps } from './../../ricos-types';

import { POLL_TYPE } from '../types';
import PollViewer from './poll-viewer';

const Poll = ({ node, nodeIndex, NodeViewContainer }: NodeViewRendererProps) => {
  const { config } = useContext(RicosViewerContext);

  return (
    <NodeViewContainer node={node} nodeIndex={nodeIndex}>
      <PollViewer
        componentData={node.pollData as ComponentData}
        settings={config[POLL_TYPE]}
        isViewMode
      />
    </NodeViewContainer>
  );
};

export default Poll;
